import { render, staticRenderFns } from "./SoftwareDetails.vue?vue&type=template&id=14cd0d56&scoped=true&"
import script from "./SoftwareDetails.vue?vue&type=script&lang=js&"
export * from "./SoftwareDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDetails.vue?vue&type=style&index=0&id=14cd0d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd0d56",
  null
  
)

export default component.exports